import React, { useState, useEffect } from "react";
import { authFetch, getUser } from "../pages/Auth";
import { COLORS } from "../chartTheme";

export default function CustomerSwitcher({ onSwitch }) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const user = getUser();

  useEffect(() => {
    if (user?.role !== "super_admin") return;
    authFetch("/api/admin/customers")
      .then(r => r.json())
      .then(d => setCustomers(d.customers || []))
      .catch(() => {});
  }, [user?.role]);

  if (user?.role !== "super_admin") return null;

  const handleSwitch = async (customerId, customerName) => {
    setLoading(true);
    try {
      const res = await authFetch("/api/admin/switch-customer", {
        method: "POST",
        body: JSON.stringify({ customer_id: customerId }),
      });
      const data = await res.json();
      if (res.ok && data.token) {
        sessionStorage.setItem("pathriva_token", data.token);
        sessionStorage.setItem("pathriva_user", JSON.stringify({
          ...user,
          customer_id: customerId,
        }));
        sessionStorage.setItem("pathriva_token_exp", String(Date.now() + data.expires_in * 1000));
        setOpen(false);
        if (onSwitch) onSwitch(customerId, customerName);
        window.location.reload();
      }
    } catch {}
    setLoading(false);
  };

  const currentCid = user?.customer_id || "";

  return (
    <div style={{ position: "relative" }}>
      <button onClick={() => setOpen(!open)} style={{
        background: "rgba(124,58,237,0.1)", border: "1px solid rgba(124,58,237,0.3)",
        borderRadius: 6, color: "#a78bfa", padding: "4px 10px", fontSize: 10,
        cursor: "pointer", fontWeight: 600, fontFamily: "inherit",
      }}>
        {currentCid.replace("pathriva_demo_", "").replace("cust_demo_", "demo_")} ▾
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "100%", right: 0, marginTop: 4,
          background: "#0d1117", border: `1px solid ${COLORS.border}`, borderRadius: 8,
          padding: 8, minWidth: 220, zIndex: 200, maxHeight: 300, overflowY: "auto",
          boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
        }}>
          <div style={{ fontSize: 9, color: COLORS.muted, padding: "4px 8px", letterSpacing: 1, textTransform: "uppercase" }}>
            Switch Customer
          </div>
          {customers.map(c => (
            <button key={c.customer_id} onClick={() => handleSwitch(c.customer_id, c.customer_name)}
              disabled={loading}
              style={{
                display: "block", width: "100%", textAlign: "left",
                padding: "8px 10px", borderRadius: 6, border: "none",
                background: c.customer_id === currentCid ? "rgba(124,58,237,0.1)" : "transparent",
                color: c.customer_id === currentCid ? "#a78bfa" : COLORS.text,
                fontSize: 12, cursor: "pointer", fontFamily: "inherit", marginBottom: 2,
              }}>
              <div style={{ fontWeight: 600 }}>{c.customer_name}</div>
              <div style={{ fontSize: 9, color: COLORS.muted }}>
                {c.customer_id} — {c.patient_count?.toLocaleString() || 0} patients
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
